module.exports = __webpack_public_path__ + "static/media/00_sognolucido.3fc7df3a.jpg";